// dev环境
const dev = {
  // ZSM_BASE_API: 'https://joofish.com',
  // ZSM_BASE_API: 'http://test.jinglinshe.com:9999',
  ZSM_BASE_API: 'http://openai.joofish.com:9999',
  ZSM_BASE_API_COMMERCE: 'https://zsm.ms.joofish.com',
}
// prod环境
const prod = {
  ZSM_BASE_API: 'https://joofish.com',
  ZSM_BASE_API_COMMERCE: 'https://zsm.ms.joofish.com'
}
const BASE_URL = process.env.NODE_ENV === 'development' ? dev : prod

export default BASE_URL
